<template>
  <div class="UserTimekeeping">
    <CCard title="Tìm kiếm" class="mb-2">
      <CCardHeader class="pt-1 pb-1">
        <span class="card-header-title">Bảng chấm công cá nhân</span>
      </CCardHeader>
      <CCardBody class="pt-1 pb-3">
        <CRow>
          <CCol sm="3" />
          <CCol sm="2">
            <CSelect label="Năm" :options="dataYear" :value.sync="valueYear" />
          </CCol>
          <CCol sm="3">
            <CSelect
              label="Trạng thái"
              :options="dataTT"
              :value.sync="valueTT"
            />
          </CCol>
          <CCol sm="2">
            <label>&nbsp;</label>
            <vs-button
              warn
              square
              class="custom_btn_search mt-0"
              @click="searchTK()"
              ><i class="bx bx-search"></i>&nbsp;Tìm kiếm</vs-button
            >
          </CCol>
          <CCol sm="1" />
        </CRow>
      </CCardBody>
    </CCard>
    <CCard class="mb-2">
      <vue-good-table
        :columns="columns"
        :rows="dataTK"
        compactMode
        :pagination-options="{
          enabled: true,
          perPageDropdownEnabled: false,
          nextLabel: 'Trang sau',
          prevLabel: 'Trang trước',
          ofLabel: 'của',
        }"
        :line-numbers="true"
        :search-options="{
          enabled: false,
          placeholder: 'Tìm kiếm',
        }"
        :sort-options="{
          enabled: false,
        }"
        :row-style-class="rowStyleClassFn"
      >
        <div slot="emptystate" style="margin-top: 10px; margin-bottom: 10px">
          Không có dữ liệu
        </div>
        <template slot="table-row" slot-scope="props">
          <div v-if="props.column.field === 'action'" class="row center">
            <div
              v-if="props.row.status == 1 || props.row.status == -1 || props.row.status == 5 || props.row.status == 6"
              class="row center"
            >
              <vs-tooltip color="success">
                <template #tooltip>
                  Xem chi tiết
                </template>
                <vs-button
                  transparent
                  @click="goTimeKeepingDetal(props.row.id)"
                  circle
                  icon
                  success
                >
                  <i class="bx bx-detail"></i>
                </vs-button>
              </vs-tooltip>
            </div>
            <div
              v-if="props.row.status == 2 || props.row.status == 3"
              class="row center"
            >
              <vs-tooltip color="square">
                <template #tooltip>
                  Cập nhật trạng thái ngày công
                </template>
                <vs-button
                  transparent
                  @click="goTimeKeepingDetal(props.row.id)"
                  circle
                  icon
                >
                  <i class="bx bx-calendar-edit"></i>
                </vs-button>
              </vs-tooltip>
            </div>
          </div>

          <div v-else-if="props.column.field === 'status'">
            <CBadge v-if="props.row.lock == 1" color="success">Đã khoá</CBadge>
            <CBadge
              v-if="props.row.status == 1 && props.row.lock != 1"
              color="primary"
              >Đã duyệt</CBadge
            >
            <CBadge
              v-else-if="props.row.status == -1 && props.row.lock != 1"
              color="warning"
              >Chờ duyệt</CBadge
            >
            <CBadge
              v-else-if="props.row.status == 2 && props.row.lock != 1"
              color="secondary"
              >Đang chấm</CBadge
            >
            <CBadge
              v-else-if="props.row.status == 3 && props.row.lock != 1"
              color="danger"
              >Trả lại</CBadge
            >
            <CBadge
              v-else-if="props.row.status == 5 && props.row.lock != 1"
              color="danger"
              >Văn phòng trả</CBadge
            >
            <CBadge
              v-else-if="props.row.status == 6 && props.row.lock != 1"
              color="success"
              >Gửi Văn phòng</CBadge
            >
          </div>
        </template>
      </vue-good-table>
    </CCard>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import ClientFactory from "@/api/ClientFactory";

import { VueGoodTable } from "vue-good-table";
const timekeepingApi = ClientFactory.get("timekeepings");

export default {
  components: {
    VueGoodTable,
  },
  data: () => ({

    columns: [
      {
        label: "Thao tác",
        field: "action",
        sortable: false,
        width: "78px",
        thClass: "text-center",
        tdClass: "text-center",
      },
      {
        label: "ID",
        field: "id",
        hidden: true,
      },
      {
        label: "Tháng",
        field: "monthyear",
        thClass: "tk-month-class text-center",
        tdClass: "tk-month-class text-center",
      },
      {
        label: "Họ và tên ",
        field: "full_name",
        width: "170px",
        thClass: "",
      },
      {
        label: "Trạng thái",
        field: "status",
        sortable: false,
        width: "90px",
        thClass: "text-center",
        tdClass: "text-center",
      },
      {
        label: "N.Công",
        field: "workday_real",
        width: "90px",
        thClass: "text-center",
        tdClass: "text-center",
      },
      {
        label: "1 ",
        field: "timesheet.d1",
        thClass: "tk-width-class",
        tdClass: "tk-width-class",
      },

      {
        label: "2 ",
        field: "timesheet.d2",
        thClass: "tk-width-class",
        tdClass: "tk-width-class",
      },

      {
        label: "3 ",
        field: "timesheet.d3",
        thClass: "tk-width-class",
        tdClass: "tk-width-class",
      },

      {
        label: "4 ",
        field: "timesheet.d4",
        thClass: "tk-width-class",
        tdClass: "tk-width-class",
      },

      {
        label: "5 ",
        field: "timesheet.d5",
        thClass: "tk-width-class",
        tdClass: "tk-width-class",
      },

      {
        label: "6 ",
        field: "timesheet.d6",
        thClass: "tk-width-class",
        tdClass: "tk-width-class",
      },

      {
        label: "7 ",
        field: "timesheet.d7",
        thClass: "tk-width-class",
        tdClass: "tk-width-class",
      },

      {
        label: "8",
        field: "timesheet.d8",
        thClass: "tk-width-class",
        tdClass: "tk-width-class",
      },
      {
        label: "9",
        field: "timesheet.d9",
        thClass: "tk-width-class",
        tdClass: "tk-width-class",
      },
      {
        label: "10",
        field: "timesheet.d10",
        thClass: "tk-width-class",
        tdClass: "tk-width-class",
      },
      {
        label: "11",
        field: "timesheet.d11",
        thClass: "tk-width-class",
        tdClass: "tk-width-class",
      },
      {
        label: "12",
        field: "timesheet.d12",
        thClass: "tk-width-class",
        tdClass: "tk-width-class",
      },
      {
        label: "13",
        field: "timesheet.d13",
        thClass: "tk-width-class",
        tdClass: "tk-width-class",
      },
      {
        label: "14",
        field: "timesheet.d14",
        thClass: "tk-width-class",
        tdClass: "tk-width-class",
      },
      {
        label: "15",
        field: "timesheet.d15",
        thClass: "tk-width-class",
        tdClass: "tk-width-class",
      },
      {
        label: "16",
        field: "timesheet.d16",
        thClass: "tk-width-class",
        tdClass: "tk-width-class",
      },
      {
        label: "17",
        field: "timesheet.d17",
        thClass: "tk-width-class",
        tdClass: "tk-width-class",
      },
      {
        label: "18",
        field: "timesheet.d18",
        thClass: "tk-width-class",
        tdClass: "tk-width-class",
      },
      {
        label: "19",
        field: "timesheet.d19",
        thClass: "tk-width-class",
        tdClass: "tk-width-class",
      },
      {
        label: "20",
        field: "timesheet.d20",
        thClass: "tk-width-class",
        tdClass: "tk-width-class",
      },
      {
        label: "21",
        field: "timesheet.d21",
        thClass: "tk-width-class",
        tdClass: "tk-width-class",
      },
      {
        label: "22",
        field: "timesheet.d22",
        thClass: "tk-width-class",
        tdClass: "tk-width-class",
      },
      {
        label: "23",
        field: "timesheet.d23",
        thClass: "tk-width-class",
        tdClass: "tk-width-class",
      },
      {
        label: "24",
        field: "timesheet.d24",
        thClass: "tk-width-class",
        tdClass: "tk-width-class",
      },
      {
        label: "25",
        field: "timesheet.d25",
        thClass: "tk-width-class",
        tdClass: "tk-width-class",
      },
      {
        label: "26",
        field: "timesheet.d26",
        thClass: "tk-width-class",
        tdClass: "tk-width-class",
      },
      {
        label: "27",
        field: "timesheet.d27",
        thClass: "tk-width-class",
        tdClass: "tk-width-class",
      },
      {
        label: "28",
        field: "timesheet.d28",
        thClass: "tk-width-class",
        tdClass: "tk-width-class",
      },
      {
        label: "29",
        field: "timesheet.d29",
        thClass: "tk-width-class",
        tdClass: "tk-width-class",
      },
      {
        label: "30",
        field: "timesheet.d30",
        thClass: "tk-width-class",
        tdClass: "tk-width-class",
      },
      {
        label: "31",
        field: "timesheet.d31",
        thClass: "tk-width-class",
        tdClass: "tk-width-class",
      },
    ],
    rows: [
      {
        session: "<button>My Action</button>",
        // ...
      },
    ],
    dataTK: [],
    valueYear: new Date().getFullYear(),
    valueMonth: (new Date().getMonth() + 1)>10 ? (new Date().getMonth() + 1) : "0"+(new Date().getMonth() + 1),
    dataYear: [
      {
        label: new Date().getFullYear() + 1,
        value: new Date().getFullYear() + 1,
      },
      {
        label: new Date().getFullYear(),
        value: new Date().getFullYear(),
      },
      {
        label: new Date().getFullYear() - 1,
        value: new Date().getFullYear() - 1,
      },
      {
        label: new Date().getFullYear() - 2,
        value: new Date().getFullYear() - 2,
      },
    ],
    valueTT: "0",
    dataTT: [
      {
        label: "Tất cả",
        value: "0",
      },
      {
        label: "Lưu tạm",
        value: "2",
      },
      {
        label: "Chờ duyệt",
        value: "-1",
      },
      {
        label: "Đã duyệt",
        value: "1",
      },
      {
        label: "Từ chối",
        value: "3",
      },
      {
        label: "Gửi Văn phòng",
        value: "6",
      },
      {
        label: "Văn phòng trả",
        value: "5",
      },
    ],
  }),
  created() {
    this.searchTK();
  },
  methods: {
    ...mapActions("ui", ["loading", "closeLoading", "notify"]),
    searchTK: async function() {
      this.loading(this.$vs);
      const params = {
        year: this.valueYear,
        status: this.valueTT,
        employee_id: this.AppActiveUser.employee_id,
      };

      const data = await timekeepingApi.get_timekeeping(params);

      this.checkResponseData(data);
      this.closeLoading();
    },
    checkResponseData: function(data) {
      if (data.status == "success") {
        this.dataTK = data.data;
        console.log(this.dataTK);
      } else {
        this.dataTK = [];
      }
    },
    goTimeKeepingDetal(id) {
      console.log(id);
      this.$router
        .push({ path: `detail`, query: { id: id, ld: 0 } })
        .catch(() => {});
    },
    rowStyleClassFn(row) {
      return row.monthyear == this.valueMonth+"/"+this.valueYear ? 'current-month' : '';
    },
  },
  computed: {
    ...mapState("auth", ["AppActiveUser"]),
  },
  destroyed() {
    this.closeLoading();
  },
};
</script>

<style lang="scss">
.UserTimekeeping {
  table.vgt-table td {
    vertical-align: inherit;
    padding: 0em 0.75em 0em 0.75em;
  }
  .tk-width-class {
    min-width: 10px !important;
    text-align: center;
  }
  .tk-name-class {
    min-width: none;
    -width: 250px !important;
  }

  .tk-month-class {
    min-width: none;
    -width: 80px !important;
  }

  .visible {
    visibility: visible !important;
  }
  .invisible {
    visibility: hidden !important;
  }
  .tk-status-class {
    min-width: 100px;
    text-align: center;
  }
  .tk-action-class {
    min-width: 150px;
    text-align: center;
  }
  .current-month{
    background-color:#f5f6c6;
  }
}
</style>
